// The cart lives in localStorage, and the browser's `storage` event only fires in
// *other* tabs. Anything that writes the cart calls notifyCartUpdated() so the
// header badge in this tab updates straight away.
export const CART_UPDATED_EVENT = 'mhs:cart-updated';

export const notifyCartUpdated = () => {
  window.dispatchEvent(new Event(CART_UPDATED_EVENT));
};
